import React, { useState, useEffect } from "react";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const TableChiTietTraBotGoc = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
    TongSoTien: 0,
  };
  const [dataLichSu, UpdateDataLichSu] = useState(dataInit);
  const DanhSachLichSuTraBotGoc = () => {
    NhanVayApi.getLichSuTraBotGocNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSu({
        ...dataLichSu,
        List: response.data.List,
        TongSoTien: response.data.TongSoTien,
      });
    });
  };

  useEffect(() => {
    DanhSachLichSuTraBotGoc();
  }, []);

  const listItem = () => {
    return (
      dataLichSu.List != null &&
      dataLichSu.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td scope="row">{index + 1}</td>
              <td className="text-center"> {getDate(item.NgayTraGoc)}</td>
              <td className="text-right">{formatNumber(item.SoTien)}</td>
              <td className="text-left">{item.GhiChu}</td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <div className="Left808x200 Table-main-morman">
      <div className="table-responsive table-new1">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th className="w-5">STT</th>
              <th className="text-center w-10">Ngày trả gốc</th>
              <th className="w-20 text-right">
                Số tiền
                <br />  
                <span className="home-new-blue">
                  {formatNumber(dataLichSu.TongSoTien)}
                </span>
              </th>
              <th className="text-left">Ghi chú</th>
            </tr>
          </thead>
          <tbody>{listItem()}</tbody>
        </table>
      </div>
    </div>
  );
};
